import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

export class MessagePopover extends Component {
  renderPopover = () => (
    <Popover id="popoverMessage">
      <Popover.Header as="h3">
        { this.props.popoverTitle }
      </Popover.Header>
      <Popover.Body>
        { this.props.popoverComponent }
      </Popover.Body>
    </Popover>
  );

  render() {
    if (this.props.popoverComponent) {
      return (
        <OverlayTrigger
          trigger="click"
          placement={ this.props.popoverPlacement || "bottom" }
          overlay={ this.renderPopover() }

        >
          { this.props.triggerComponent }
        </OverlayTrigger>
      );
    }
    return null;
  }
}

MessagePopover.propTypes = {
  triggerComponent: PropTypes.object,
  popoverComponent: PropTypes.object,
  popoverTitle: PropTypes.object,
  popoverPlacement: PropTypes.string,
};
